module.exports = __webpack_public_path__ + "static/media/06.34332f9f.mp3";